import React from "react";

export default props => (
  <div style={{ textAlign: "center", ...props.style }}>
    <div>{props.children}</div>
  </div>
);
